import PropTypes from 'prop-types';
import React from 'react';

import { RelatedRecommendationQuery } from '../../../api/queries/recommendation.gql';
import PageQuery from '../../PageQuery';
import RecommendationBlock from '../RecommendationBlock';

const RelatedRecommendation = ({ id, type }) => (
  <PageQuery
    query={RelatedRecommendationQuery}
    variables={{
      contentId: id,
      limit: 4,
      contentType: type,
    }}
  >
    {({ data }) => {
      const { edges } = data.relatedRecommendation;

      if (!edges) {
        return null;
      }

      return (
        <RecommendationBlock
          results={edges}
          title="Meer over dit onderwerp"
          recomType="gerelateerd"
        />
      );
    }}
  </PageQuery>
);

RelatedRecommendation.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default RelatedRecommendation;
